var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.25C9.33968 1.25 8.22688 1.71094 7.40641 2.53141C6.58594 3.35188 6.125 4.46468 6.125 5.625V8.125C5.46196 8.125 4.82607 8.38839 4.35723 8.85723C3.88839 9.32607 3.625 9.96196 3.625 10.625V16.25C3.625 16.913 3.88839 17.5489 4.35723 18.0178C4.82607 18.4866 5.46196 18.75 6.125 18.75H14.875C15.538 18.75 16.1739 18.4866 16.6428 18.0178C17.1116 17.5489 17.375 16.913 17.375 16.25V10.625C17.375 9.96196 17.1116 9.32607 16.6428 8.85723C16.1739 8.38839 15.538 8.125 14.875 8.125V5.625C14.875 3.20833 12.9167 1.25 10.5 1.25ZM13.625 8.125V5.625C13.625 4.7962 13.2958 4.00134 12.7097 3.41529C12.1237 2.82924 11.3288 2.5 10.5 2.5C9.6712 2.5 8.87634 2.82924 8.29029 3.41529C7.70424 4.00134 7.375 4.7962 7.375 5.625V8.125H13.625Z",
    fill: "#CC5029"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e44a876333ae7cb7d7723ae50731b2d1.svg";
export { ForwardRef as ReactComponent };